import { createSlice } from '@reduxjs/toolkit'

/**
 * Tracks whether the current session has hit a server-enforced 403.
 *
 * Set by {@link forbiddenMiddleware} when any outpatient query is rejected with
 * status 403 — the backend, not the client, is the authority on which data a
 * signed-in user may read, so authorization failures only surface once a request
 * comes back. Kept in the store rather than handled per-query so a single place
 * can turn it into an unauthorized page. `forbiddenCleared` exists so a stale
 * 403 never strands a later, authorized view.
 */
interface ForbiddenState {
  isForbidden: boolean
}

const initialState: ForbiddenState = { isForbidden: false }

export const forbiddenSlice = createSlice({
  name: 'forbidden',
  initialState,
  reducers: {
    forbiddenDetected: (state) => {
      state.isForbidden = true
    },
    forbiddenCleared: (state) => {
      state.isForbidden = false
    },
  },
})

export const { forbiddenDetected, forbiddenCleared } = forbiddenSlice.actions
